module.exports = __webpack_public_path__ + "img/ic_private.590f1366.svg";